import { PageHeader } from "@/components/ui-bits";
import { Truck, Package, Zap } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const Verzending = () => {
  const { t } = useLang();
  return (
  <div className="px-6 sm:px-12 lg:px-20 pt-32 pb-24 max-w-4xl">
    <PageHeader
      eyebrow={t("ship.eyebrow")}
      title={<>Verzending & <span className="italic normal-case text-gold">{t("ship.title2")}</span></>}
      sub={t("ship.sub")}
    />
    <div className="space-y-4">
      {[
        [<Truck size={16} key="a" />, t("ship.t1"), t("ship.b1")],
        [<Zap size={16} key="b" />, t("ship.t2"), t("ship.b2")],
        [<Package size={16} key="c" />, t("ship.t3"), t("ship.b3")],
      ].map(([icon, title, body]) => (
        <div key={title} className="flex items-start gap-5 border border-gold/15 bg-ink p-6">
          <span className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/30 text-gold shrink-0">{icon}</span>
          <div>
            <h2 className="font-serif text-xl text-cream">{title}</h2>
            <p className="mt-2 text-sm text-mist leading-relaxed">{body}</p>
          </div>
        </div>
      ))}
    </div>
    <p className="mt-8 font-mono text-[10px] tracking-[0.2em] uppercase text-smoke">
      {t("ship.note")}
    </p>
  </div>
  );
};

export default Verzending;
